import React, {useState, Fragment} from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Title from 'components/Titulo';
import PasoAPasoHorizontal from 'components/pasoAPasoHorizontal';
import DatosDeLaEmpresa from './DatosDeLaEmpresa';
import DatosDelPropietario from './DatosDelPropietario';
import PersonaQueEmiteFactura from './PersonaQueEmiteFactura';
import CaracteristicaDelMedio from './caracteristicasDelMedio';
import DialogoPantallaCompleta from 'components/Dialogo/DialogoPantallaCompleta';
import { setearDatosAlStore } from 'store/actions/customAction';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';

const FormularioDeInscripcion= ({title, openFullScreenDialog, handleClose, obtenerRegistros}) => {
  const dispatch = useDispatch();
  const {activeStep, numberStep, datosDeEmpresa, listadoPersonaIndividual, personaIndividual, personaLegal, listadoDeCaracteristicasDelMedio, arrendatario, idSolicitud} = useSelector( ({medio}) => medio);

  const [steps] = useState([
    {id: 0,  label: 'Datos de la empresa'}, {id: 1, label: "Datos del propietario"}, {id: 2, label: "Datos del propietario (Persona que emite factura)"},
    {id: 3, label: "Características del medio"}]);

  const obtenerContenidoDePasos = (step) => {
    switch (step) {
      case 0:
        // return <CaracteristicaDelMedio
        // activeStep={activeStep} numberStep={numberStep}
        // datosDeEmpresa={datosDeEmpresa} listadoPersonaIndividual={listadoPersonaIndividual} personaIndividual={personaIndividual} personaLegal={personaLegal}
        // listadoDeCaracteristicasDelMedio={listadoDeCaracteristicasDelMedio}
        // />
        return <DatosDeLaEmpresa activeStep={activeStep} numberStep={numberStep} datosDeEmpresa={datosDeEmpresa} idSolicitud={idSolicitud} />;
      case 1:
        return renderizarAlSiguientePaso(steps[step])
      case 2:
        return renderizarAlSiguientePaso(steps[step])
      case 3:
        return renderizarAlSiguientePaso(steps[step])
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const renderizarAlSiguientePaso = (currentStep) => {
    switch(currentStep?.id) {
      case 1:
        return <DatosDelPropietario activeStep={activeStep} numberStep={numberStep} datosDeEmpresa={datosDeEmpresa} listadoPersonaIndividual={listadoPersonaIndividual} personaLegal={personaLegal} idSolicitud={idSolicitud} />
      case 2:
        return <PersonaQueEmiteFactura activeStep={activeStep} numberStep={numberStep} personaIndividual={personaIndividual} idSolicitud={idSolicitud} />
      case 3:
        return <CaracteristicaDelMedio
          activeStep={activeStep} numberStep={numberStep}
          datosDeEmpresa={datosDeEmpresa} listadoPersonaIndividual={listadoPersonaIndividual} personaIndividual={personaIndividual} personaLegal={personaLegal}
          listadoDeCaracteristicasDelMedio={listadoDeCaracteristicasDelMedio}
          arrendatario={arrendatario}
          idSolicitud={idSolicitud}
          handleClose={handleClose}
          obtenerRegistros={obtenerRegistros}
          />
      default:
        return <Typography>No existen Componente para mostrar</Typography>;
    }
  }

  const cerrarPantallaCompleta = () => {
    dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.CLEAN_ALL_REDUCER}));
    handleClose(true)
  }

  return (
    <DialogoPantallaCompleta
        openFullScreenDialog={openFullScreenDialog}
        handleClose={cerrarPantallaCompleta}
        title={title}
        fullscreen={true}
    >
      <Fragment>
          <Card>
              <CardContent>
              <Title title={`${idSolicitud ? "Editar " : ""} Formulario de inscripción`} icon={"registro_escritos"}/>
                  <PasoAPasoHorizontal
                    cerrarPantallaCompleta={() => {}}
                    steps={steps}
                    obtenerContenidoDePasos={obtenerContenidoDePasos}
                    activeStepProp={activeStep}
                    numberStepProp={numberStep}
                    showButtonStepper={false}
                />
              </CardContent>
          </Card>
      </Fragment>
    </DialogoPantallaCompleta>
  );
}

export default FormularioDeInscripcion;